module.exports = __webpack_public_path__ + "static/media/memberDate.svg";